// extracted by mini-css-extract-plugin
export default {"clients":"Clients_clients__+c0su","clientsItem":"Clients_clientsItem__FrCQw"};